import * as React from 'react'
import { Provider } from 'react-redux'
import store from '../../../store'
import WarehouseRentList from './warehouse_rent_list'
import { RentList } from './warehouse_rent_list/warehouse_rent_list_types'

interface WarehouseRentListAppProps {
  warehouseId: number
  isOverview?: boolean
  initialWarehouseRentList?: RentList | null
  initialRentedItems?: Record<string, any> | null
}

export default function WarehouseRentListApp(props: WarehouseRentListAppProps): React.ReactElement {
  return (
    <Provider store={store}>
      <WarehouseRentList {...props} />
    </Provider>
  )
}
